
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.688 3.194a1.116 1.116 0 010 1.549l-9.067 9.31a1.047 1.047 0 01-1.509 0l-4.8-4.93a1.116 1.116 0 010-1.548 1.047 1.047 0 011.509 0l4.046 4.154 8.312-8.535a1.047 1.047 0 011.509 0z","fill":"#038F11"}})])
          )
        }
      }
    